// @flow

import * as React from 'react';
import { Route, Link } from 'react-router-dom';

import { Header } from './components/Header';
import { Home } from './routeComponents/Home';
import { About } from './routeComponents/About';

import AdsumKeyboard from '@adactive/arc-keyboard';

import brace from 'brace';
import AceEditor from 'react-ace';

import 'brace/mode/jsx';
import 'brace/theme/monokai';

import './App.css';

type PropsType = {||};

class App extends React.Component<PropsType> {
    constructor(props) {
        super(props);

        this.onKeyClicked = this.onKeyClicked.bind(this);
    }

    onKeyClicked(key) {
        console.log(key);
    }

    render() {

        const keyboardCSS = {
            top: '70px'
        };

        const keyboardLineCSS = {
            padding: '0'
        };

        const buttonCSS = {
            backgroundColor: 'black',
            height: '48px',
            color: 'white'
        };

        return (
            <div className="App">
                <Header logo={"http://adactivesas.github.io/adsum-react-components/logo.jpg"} />

                <br/>
                <div className="comp" >
                    <AdsumKeyboard isOpen={true} lang={"en"} onKeyClicked={this.onKeyClicked} currentValue=''/>
                </div>
                <div className="code">
                    <AceEditor
                        mode="jsx"
                        theme="monokai"
                        name="UNIQUE_ID_OF_DIV"
                        editorProps={{$blockScrolling: true}}
                        fontSize={14}
                        value={`import AdsumKeyboard from '@adactive/arc-keyboard';
...
constructor(props) {
    super(props);

    this.onKeyClicked = this.onKeyClicked.bind(this);
}

onKeyClicked(key) {
    console.log(key);
}

<AdsumKeyboard
    isOpen={true}
    lang={'en'}
    onKeyClicked={this.onKeyClicked}
    currentValue=''
/>`
                        }
                        height='350px'
                        width='700px'
                    />
                </div>
                <br/>
                <div className="comp" >
                    <AdsumKeyboard
                        isOpen={true}
                        lang={"fr"}
                        onKeyClicked={this.onKeyClicked}
                        currentValue=''
                        keyboardCSS={keyboardCSS}
                        keyboardLineCSS={keyboardLineCSS}
                        buttonCSS={buttonCSS}
                    />
                </div>
                <div className="code">
                    <AceEditor
                        mode="jsx"
                        theme="monokai"
                        name="UNIQUE_ID_OF_DIV"
                        editorProps={{$blockScrolling: true}}
                        fontSize={14}
                        value={`import AdsumKeyboard from '@adactive/arc-keyboard';
...
constructor(props) {
    super(props);

    this.onKeyClicked = this.onKeyClicked.bind(this);
}

onKeyClicked(key) {
    console.log(key);
}

const keyboardCSS = {
    top: '70px'
};

const keyboardLineCSS = {
    padding: '0'
};

const buttonCSS = {
    backgroundColor: 'black',
    height: '48px',
    color: 'white'
};

<AdsumKeyboard
    isOpen={true}
    lang={'fr'}
    onKeyClicked={this.onKeyClicked}
    currentValue=''
/>`
                        }
                        height='350px'
                        width='700px'
                    />
                </div>
                {/*<nav>
                    <Link to="/">Home</Link>
                    <Link to="/about-us">About</Link>
                </nav>
                <main>
                    <Route exact path="/" component={Home} />
                    <Route exact path="/about-us" component={About} />
                </main>*/}
            </div>
        );
    }
}

export default App;



// WEBPACK FOOTER //
// ./src/App.js